import { action, observable } from 'mobx';
import apiCaller from '../../utils/api-caller';
import { v4 } from 'uuid';

class CmsSidebarStore {
  @observable data = [];
  @observable images = [];

  @observable sidebars = [];
  @observable sidebar = null;

  @observable selectedsidebar = null;
  @observable selectedimages = [];

  @observable showModal = false;
  @observable modalTitle = '';

  @observable updateLoading = false;

  @action getAll() {
    return apiCaller.CmsSidebars.get().then(resp => {
      if (!resp.isError) {
        if (resp.data) {
          this.data = resp.data;
        }
      }
    })
  }

  @action getAllByLanguage() {
    const languageCode = window.localStorage.getItem('lang') || 'en';
    return apiCaller.CmsSidebars.getByLanguageCode(languageCode).then(resp => {
      if (resp) {
        this.sidebars = resp;
      }
    })
  }

  @action getByIdAndLanguage(id) {
    const languageCode = window.localStorage.getItem('lang') || 'en';
    return apiCaller.CmsSidebars.getByIdAndLanguageCode(id, languageCode).then(resp => {
      if (resp) {
        this.selectedsidebar = resp;
        this.selectedimages = [];
        if (this.selectedsidebar.bannerUrl) {
          try {
            let imagesJson = JSON.parse(this.selectedsidebar.bannerUrl);
            imagesJson.map(imageJson => {
              return imageJson.isLoading = false;
            });
            this.selectedimages = imagesJson;
          } catch {
            this.selectedimages.push({
              id: v4(),
              url: this.selectedsidebar.bannerUrl,
              isLoading: false
            });
          }
        }
      }
    })
  }

  @action getDataById(id) {
    this.modalTitle = 'Update Hotel Facility';
    return apiCaller.CmsSidebars.getById(id).then(resp => {
      if (!resp.isError) {
        if (resp.data) {
          this.images = [];
          this.sidebar = resp.data;

          if (this.sidebar.bannerUrl) {
            try {
              let imagesJson = JSON.parse(this.sidebar.bannerUrl);
              imagesJson.map(imageJson => {
                return imageJson.isLoading = false;
              });
              this.images = imagesJson;
            } catch {
              this.images.push({
                id: v4(),
                url: this.sidebar.bannerUrl,
                isLoading: false
              });
            }
          }

          this.images.push({
            id: v4(),
            url: '',
            isLoading: false
          });

          this.showModal = true;
        }
      }
    })
  }

  @action initCreate(languages) {
    this.modalTitle = 'Add Hotel Facility';
    this.sidebar = {
      'id': 0,
      'bannerUrl': '',
      'sort': 1,
      'hasDownload': false,
      'downloadUrl': '',
      'sidebarLanguages': []
    };

    languages.map(language => {
      this.sidebar.sidebarLanguages.push({
        'id': 0,
        'sidebarId': 0,
        'languageId': language.id,
        'title': '',
        'description': ''
      });

      return language;
    })

    this.images = [{
      id: v4(),
      url: '',
      isLoading: false
    }];

    this.showModal = true;
  }

  @action create() {
    this.updateLoading = true;

    if (!this.sidebar.hasDownload) {
      this.sidebar.downloadUrl = '';
    }

    this.sidebar.bannerUrl = JSON.stringify(this.images.filter(fi => fi.url !== ''));
    return apiCaller.CmsSidebars.create(this.sidebar);
  }

  @action update() {
    this.updateLoading = true;

    if (!this.sidebar.hasDownload) {
      this.sidebar.downloadUrl = '';
    }

    this.sidebar.bannerUrl = JSON.stringify(this.images.filter(fi => fi.url !== ''));
    return apiCaller.CmsSidebars.update(this.sidebar.id, this.sidebar);
  }

  @action delete(id) {
    return apiCaller.CmsSidebars.delete(id);
  }

  @action cancel() {
    this.getData();
  }

  @action setsort(value) {
    this.sidebar.sort = value;
  }

  @action sethasDownload(value) {
    this.sidebar.hasDownload = value;

    if (!value) {
      this.sidebar.downloadUrl = '';
    }
  }

  @action setdownloadUrl(value) {
    this.sidebar.downloadUrl = value;
  }

  @action settitle(langId, value) {
    let lang = this.sidebar.sidebarLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.title = value;
    }
  }

  @action setdescription(langId, value) {
    let lang = this.sidebar.sidebarLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.description = value;
    }
  }

  @action setImageUrlById(id, value) {
    let image = this.images.find(fi => fi.id === id);
    if (image) {
      image.url = value;
    }

    let blankImage = this.images.find(fi => fi.url === '');
    if (!blankImage) {
      this.images.push({
        id: v4(),
        url: '',
        isLoading: false
      });
    }
  }

  @action setImageIsLoadingById(id, isLoading) {
    let image = this.images.find(fi => fi.id === id);
    if (image) {
      image.isLoading = isLoading;
    }
  }

  @action removeImageById(id) {
    this.images = this.images.filter(fi => fi.id !== id);
  }

  @action setsidebar(value) {
    this.sidebar = value;
  }

  @action setupdateLoading(value) {
    this.updateLoading = value;
  }

  @action setshowModal(value) {
    this.showModal = value
  }

  @action resetData() {
    this.sidebar = null;

    this.selectedsidebar = null;
    this.selectedimages = [];
  }
}

export default new CmsSidebarStore();